<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";

  // Get the block data
  export let blok;
</script>

<section
  class="maintenance-page section-header-width mx-auto"
  use:storyblokEditable={blok}
>
  <svg
    class="logo"
    viewBox="0 0 77 25"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M0.490372 18.5208C-0.412456 19.0033 0.0302658 20.5327 1.02349 20.8593L13.6399 24.9922C13.6758 25.0035 13.7141 25.0024 13.75 24.9888L27.034 19.6075C27.1684 19.5529 27.1615 19.364 27.0236 19.3185L14.9646 15.3643C13.881 15.0104 13.4301 13.4947 14.734 12.8028L26.6423 6.47942C27.5451 5.99694 27.1024 4.46758 26.1091 4.141L13.4916 0.00809421C13.4556 -0.00328495 13.4174 -0.00214703 13.3815 0.011508L0.0986443 5.39271C-0.0357947 5.44733 -0.028841 5.63622 0.109075 5.68174L12.168 9.636C13.2517 9.98989 13.7025 11.5056 12.3987 12.1974L0.490372 18.5208Z"
      />
      <path
        d="M34.3863 15.9194L40.1614 8.9531H34.5462V7.51364H42.1061V9.08055L36.4179 16.0184H42.4689V17.4863H34.3863V15.9194Z"
      />
      <path d="M43.556 10.363H45.2677V17.4863H43.556V10.363Z" />
      <path
        d="M46.6458 10.363H48.3436L48.3147 11.9447H48.4016C48.5754 11.2176 49.4029 10.1491 50.9119 10.1491C52.7836 10.1491 54.1477 11.6591 54.1477 13.8814C54.1477 16.1038 52.8566 17.6991 50.9698 17.6991C49.3739 17.6991 48.6334 16.6022 48.4155 15.9331H48.3425V20.0501H46.6446V10.3619L46.6458 10.363ZM50.3312 16.2893C51.4774 16.2893 52.3919 15.4916 52.3919 13.9099C52.3919 12.3282 51.4925 11.5453 50.3312 11.5453C49.17 11.5453 48.2996 12.343 48.2996 13.9099C48.2996 15.4768 49.17 16.2893 50.3312 16.2893Z"
      />
      <path
        d="M55.2209 15.5052V7.51251H56.9037V15.2196C56.9037 15.7749 57.1216 16.089 57.7022 16.089H58.167V17.4852H57.2525C55.9174 17.4852 55.2209 16.8298 55.2209 15.5052Z"
      />
      <path
        d="M58.9504 7.51366H60.6622V9.19436H58.9504V7.51366ZM58.9504 10.363H60.6622V17.4863H58.9504V10.363Z"
      />
      <path
        d="M62.0552 10.363H63.7531L63.7241 12.1871H63.7971C64 11.0901 64.9723 10.1502 66.2344 10.1502C67.9752 10.1502 68.7447 11.2187 68.7447 13.1702V17.4863H67.033V13.383C67.033 12.1723 66.4813 11.5305 65.495 11.5305C64.4068 11.5305 63.7543 12.6274 63.7543 13.7528V17.4852H62.0564V10.3619L62.0552 10.363Z"
      />
      <path
        d="M69.6719 13.9247C69.6719 11.6022 71.1959 10.1491 73.3864 10.1491C75.5768 10.1491 76.9988 11.3883 76.9988 13.7255C76.9988 13.9816 76.9849 14.167 76.956 14.3093H71.3118C71.3698 15.6907 72.2552 16.403 73.4153 16.403C74.3008 16.403 74.9973 16.0036 75.2291 15.1639H76.898C76.6222 16.8446 75.1862 17.6991 73.3284 17.6991C71.3257 17.6991 69.6719 16.403 69.6719 13.9235V13.9247ZM75.2732 13.2977C75.2732 12.1575 74.5187 11.3746 73.3435 11.3746C72.1683 11.3746 71.4277 12.1723 71.3559 13.2977H75.2732Z"
      />
      <path d="M45.2677 7.51366H43.556V9.19436H45.2677V7.51366Z" />
    </g>
    <defs>
      <clipPath id="clip0_707_5001">
        <rect width="77" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <h1 class="main-heading type:h4">{blok.heading}</h1>
  <p class="main-subheading">{blok.subheading}</p>
</section>

<style lang="postcss">
  .maintenance-page {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    max-width: 600px;
  }

  .logo {
    width: 100px;
    height: auto;
  }

  .main-heading {
    text-align: center;
  }

  .main-subheading {
    font-size: 18px;
  }

  :global(header.is-maintenance-page) {
    display: none !important;
  }
</style>
